import { graphqlRequest } from '../graphql/client';
import {
  PASSWORD_RESET_TOKEN_STATUS_QUERY,
  REQUEST_PASSWORD_RESET_MUTATION,
  RESET_PASSWORD_MUTATION,
} from '../graphql/documents';

interface RequestPasswordResetResponse {
  requestPasswordReset: boolean;
}

interface PasswordResetTokenStatusResponse {
  passwordResetTokenStatus: {
    valid: boolean;
    email: string | null;
    displayName: string | null;
    expiresAt: string | null;
    error: string | null;
  };
}

interface ResetPasswordResponse {
  resetPassword: boolean;
}

export async function requestPasswordReset(email: string) {
  const data = await graphqlRequest<RequestPasswordResetResponse>(REQUEST_PASSWORD_RESET_MUTATION, { email });
  return data.requestPasswordReset;
}

export async function fetchPasswordResetTokenStatus(token: string) {
  const data = await graphqlRequest<PasswordResetTokenStatusResponse>(PASSWORD_RESET_TOKEN_STATUS_QUERY, { token });
  return data.passwordResetTokenStatus;
}

export async function resetPassword(token: string, password: string) {
  const data = await graphqlRequest<ResetPasswordResponse>(RESET_PASSWORD_MUTATION, { token, password });
  return data.resetPassword;
}
